import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { NeighborhoodFragment } from '@api/fragments'
import { INeighborhood } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteSpacesFromNeighborhood: {
    neighborhood: INeighborhood
  }
}

const mutation = gql`
  mutation DeleteSpacesFromNeighborhood($input: DeleteSpacesFromNeighborhoodInput!) {
    deleteSpacesFromNeighborhood(input: $input) {
      neighborhood {
        ...NeighborhoodFragment
      }
    }
  }
  ${NeighborhoodFragment}
`

const mutateHandler = handleFetchResult<IPayload, INeighborhood>({
  handler: (data) => data.deleteSpacesFromNeighborhood.neighborhood,
  name: 'Neighborhood Space',
})

export default function addEmployeesToNeighborhood(
  neighborhoodId: string,
  spaceIds: string[]
): Promise<INeighborhood> {
  const input = { neighborhoodId, spaceIds }

  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}
